import { render } from "./profile.vue?vue&type=template&id=1d576640&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"

import "./profile.vue?vue&type=style&index=0&id=1d576640&scoped=true&lang=css"
import "./profile.vue?vue&type=style&index=1&id=1d576640&lang=css"

import exportComponent from "/home/runner/work/faber-mieruca-connect/faber-mieruca-connect/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d576640"]])

export default __exports__